// import React, { useState } from "react";
// import axios from "axios";
// import { CircularProgress, Button } from "@mui/material";
// import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
// import CustomInput from "../../shared/utils/Input";

// const DragDropUpload = ({
//   onUploadComplete,
//   accept = "image/*",
//   maxSize = 2 * 1024 * 1024,
//   label = "Browse Files",
//   existingFile = "",
//   loading,
//   setOpen,
//   handleSave,
//   role,
//   onChangeDescription,
//   creativeDescription,
// }) => {
//   const [dragActive, setDragActive] = useState(false);
//   const [fileUrl, setFileUrl] = useState(existingFile || "");
//   const [fileName, setFileName] = useState(existingFile || "");
//   const [fileUploading, setFileUploading] = useState(false);
//   const [referenceDescription, setReferenceDescription] = useState(
//     creativeDescription || "",
//   );

//   const validateFile = (file) => {
//     if (!file) return false;

//     if (file.size > maxSize) {
//       alert(`File size must be less than ${maxSize / (1024 * 1024)}MB`);
//       return false;
//     }

//     return true;
//   };

//   const uploadFile = async (file) => {
//     try {
//       setFileUploading(true);

//       const token = localStorage.getItem("token");
//       const formData = new FormData();
//       formData.append("files", file);

//       const response = await axios.post(
//         `${process.env.REACT_APP_URL}/upload`,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "multipart/form-data",
//           },
//         },
//       );

//       if (response.data.success) {
//         const uploadedUrl = response.data.data[0];

//         setFileName(file.name);
//         setFileUrl(uploadedUrl);

//         onUploadComplete?.(uploadedUrl);
//       }
//     } catch (error) {
//       console.error("Upload error", error);
//     } finally {
//       setFileUploading(false);
//     }
//   };

//   const handleFile = (file) => {
//     if (!validateFile(file)) return;
//     uploadFile(file);
//   };

//   const handleChange = (e) => {
//     const file = e.target.files[0];
//     handleFile(file);
//   };

//   const handleDrop = (e) => {
//     e.preventDefault();
//     setDragActive(false);
//     const file = e.dataTransfer.files[0];
//     handleFile(file);
//   };

//   const handleView = () => {
//     if (fileUrl) {
//       window.open(fileUrl, "_blank");
//     }
//   };
//   const handleDelete = () => {
//     setFileName("");
//     setFileUrl("");

//     onUploadComplete?.("");
//   };

//   return (
//     <div className="rounded-xl p-4 shadow-[0_0_15px_rgba(0,0,0,0.15)] flex flex-col gap-2 h-full">
//       <div className=" flex flex-col flex-grow gap-2">
//         <div>
//           <h2 className="font-semibold text-lg">Media Upload</h2>
//           <p className="text-sm text-gray-500 mb-4">Add your documents here</p>
//         </div>
//         <div
//           className={`border-2 flex-grow-0 h-full rounded-xl p-4 text-center transition ${
//             dragActive
//               ? "border-blue-600 bg-blue-200"
//               : "border-blue-500 bg-blue-100"
//           }`}
//           onDragOver={(e) => {
//             e.preventDefault();
//             setDragActive(true);
//           }}
//           onDragLeave={() => setDragActive(false)}
//           onDrop={handleDrop}
//         >
//           <div className="flex flex-col justify-center items-center h-full">
//             <img
//               src="/assests/uploadFile.webp"
//               alt="upload"
//               className="object-contain h-10 w-10"
//             />

//             <span className="mt-2">Drag and drop your file</span>
//             <span className="text-gray-600 my-2">or</span>

//             <label className="border border-blue-500 py-1 px-3 bg-white rounded-lg text-blue-500 cursor-pointer hover:bg-blue-50">
//               {label}
//               <input
//                 hidden
//                 type="file"
//                 accept={accept}
//                 onChange={handleChange}
//               />
//             </label>

//             {fileUploading && (
//               <div className="mt-3">
//                 <CircularProgress size={20} />
//               </div>
//             )}
//           </div>
//         </div>
//         {role == "client" && (
//           <CustomInput
//             name="description"
//             placeholder="Enter Description"
//             title="Description"
//             value={referenceDescription}
//             size="small"
//             onChange={(e) => {
//               setReferenceDescription(e.target.value);
//               onChangeDescription?.(e.target.value);
//             }}
//           />
//         )}

//         <div className="flex items-center justify-between gap-2 mt-2 w-full">
//           <div className="flex items-center gap-2">
//             {fileName && <CheckCircleOutlineIcon sx={{ color: "green" }} />}

//             <span className="text-sm text-gray-500 truncate">
//               {fileName || "No file selected"}
//             </span>
//           </div>

//           {fileName && (
//             <div className="flex gap-2">
//               <Button size="small" variant="outlined" onClick={handleView}>
//                 View
//               </Button>

//               <Button
//                 size="small"
//                 variant="outlined"
//                 color="error"
//                 onClick={handleDelete}
//               >
//                 Delete
//               </Button>
//             </div>
//           )}

//           <div className="flex gap-3 ml-auto">
//             <Button variant="outlined" onClick={() => setOpen(false)}>
//               Cancel
//             </Button>

//             <Button
//               disabled={loading || !fileName}
//               variant="contained"
//               onClick={handleSave}
//             >
//               {loading ? (
//                 <CircularProgress size={20} color="inherit" />
//               ) : (
//                 "SAVE"
//               )}
//             </Button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DragDropUpload;

import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { CircularProgress } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CustomInput from "../../shared/utils/Input";
import Swal from "sweetalert2";
import { Tooltip, IconButton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import GlobalButton from "../../shared/utils/GlobalButton.jsx";

const DragDropUpload = ({
  onUploadComplete,
  accept = "image/*",
  maxSize = 2 * 1024 * 1024,
  label = "Browse Files",
  existingFile = "",
  loading,
  setOpen,
  handleSave,
  handleDelete,
  role,
  onChangeDescription,
  creativeDescription,
}) => {
  const [dragActive, setDragActive] = useState(false);
  const [fileName, setFileName] = useState("");
  const [fileUrl, setFileUrl] = useState(existingFile || "");
  const [fileUploading, setFileUploading] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [pasteError, setPasteError] = useState("");

  const [referenceDescription, setReferenceDescription] = useState(
    creativeDescription || "",
  );
  const fileInputRef = useRef(null);
  const dropZoneRef = useRef(null);
  /*
  =========================
  FILE VALIDATION
  =========================
  */
  useEffect(() => {
    if (existingFile) {
      setFileUrl(existingFile);

      const fileNameFromUrl = existingFile.split("/").pop();

      setFileName(fileNameFromUrl);

      setShowPreview(true);
    }
  }, [existingFile]);

  const validateFile = (file) => {
    if (!file) return false;

    if (file.size > maxSize) {
      alert(`File size must be less than ${maxSize / (1024 * 1024)}MB`);
      return false;
    }

    if (accept && accept !== "*") {
      const acceptTypes = accept.split(",").map((type) => type.trim());
      const fileType = file.type;
      const fileExtension = file.name.split(".").pop().toLowerCase();

      const isValid = acceptTypes.some((type) => {
        if (type.startsWith(".")) {
          return fileExtension === type.substring(1);
        } else if (type.includes("/")) {
          if (type.endsWith("/*")) {
            const baseType = type.replace("/*", "");
            return fileType.startsWith(baseType + "/");
          }
          return fileType === type;
        }
        return false;
      });

      if (!isValid) {
        alert(`Invalid file type. Please upload: ${accept}`);
        return false;
      }
    }

    return true;
  };

  /*
  =========================
  UPLOAD FILE
  =========================
  */

  const uploadFile = async (file) => {
    try {
      setFileUploading(true);
      setPasteError("");

      const token = localStorage.getItem("token");

      const formData = new FormData();
      formData.append("files", file);

      const response = await axios.post(
        `${process.env.REACT_APP_URL}/upload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (response.data.success) {
        const uploadedUrl = response.data.data[0];

        setFileName(file.name);
        setFileUrl(uploadedUrl);
        setShowPreview(true);

        onUploadComplete?.(uploadedUrl);
      }
    } catch (error) {
      console.error("Upload error", error);
      setPasteError("Failed to upload file. Please try again.");
    } finally {
      setFileUploading(false);
    }
  };

  /*
  =========================
  HANDLE FILE
  =========================
  */

  const handleFile = (file) => {
    if (!validateFile(file)) return;
    uploadFile(file);
  };

  const handleChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    handleFile(file);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);

    const file = e.dataTransfer.files[0];

    handleFile(file);
  };

  const handlePaste = async (e) => {
    const isPastingInsideDropZone = dropZoneRef.current?.contains(e.target);
    if (!isPastingInsideDropZone) {
      return;
    }

    e.preventDefault();

    const items = e.clipboardData?.items;

    if (!items) return;

    let imageFile = null;

    for (let i = 0; i < items.length; i++) {
      const item = items[i];

      if (item.type.startsWith("image/")) {
        imageFile = item.getAsFile();
        break;
      }
    }

    if (!imageFile && e.clipboardData?.files?.length > 0) {
      const file = e.clipboardData.files[0];
      if (file.type.startsWith("image/")) {
        imageFile = file;
      }
    }

    if (imageFile) {
      const fileExtension = imageFile.type.split("/")[1] || "png";
      const newFile = new File(
        [imageFile],
        `pasted-image-${Date.now()}.${fileExtension}`,
        { type: imageFile.type },
      );

      handleFile(newFile);
    }
  };

  useEffect(() => {
    const handleGlobalPaste = (e) => {
      if (dropZoneRef.current) {
        const isPastingInsideDropZone = dropZoneRef.current.contains(e.target);
        if (!isPastingInsideDropZone) {
          return;
        }

        const items = e.clipboardData?.items;
        if (!items) return;

        let imageFile = null;
        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          if (item.type.startsWith("image/")) {
            imageFile = item.getAsFile();
            break;
          }
        }

        if (imageFile) {
          const fileExtension = imageFile.type.split("/")[1] || "png";
          const newFile = new File(
            [imageFile],
            `pasted-image-${Date.now()}.${fileExtension}`,
            { type: imageFile.type },
          );

          handleFile(newFile);
        }
      }
    };

    document.addEventListener("paste", handleGlobalPaste);

    return () => {
      document.removeEventListener("paste", handleGlobalPaste);
    };
  }, []);

  /*
  =========================
  ACTIONS
  =========================
  */

  const handleEdit = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
      fileInputRef.current.click();
    } else {
      console.log("File input ref not found");
    }
  };

  return (
    <div className="rounded-xl p-4 shadow-[0_0_15px_rgba(0,0,0,0.15)] flex flex-col gap-2 h-full">
      <div className="flex flex-col gap-2">
        {/* HEADER */}

        <div className="flex items-center gap-2">
          <h2 className="font-semibold text-lg">Media Upload</h2>
          <Tooltip
            title={
              <div className="flex items-center gap-1.5 text-xs">
                <kbd className="px-1.5 py-0.5 bg-white/20 rounded border border-white/30 text-white text-[10px] font-mono">
                  Ctrl
                </kbd>
                <span>+</span>
                <kbd className="px-1.5 py-0.5 bg-white/20 rounded border border-white/30 text-white text-[10px] font-mono">
                  V
                </kbd>
                <span className="ml-1">to update existing image</span>
              </div>
            }
            arrow
            placement="right"
          >
            <IconButton size="small" sx={{ color: "#6b7280" }}>
              <InfoOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
        <p className="text-sm text-gray-500 mb-4">Add your documents here</p>

        {/* DRAG DROP / PREVIEW BOX */}

        <div
          ref={dropZoneRef}
          className={`border-2 h-[260px] rounded-xl p-4 text-center transition relative ${
            dragActive
              ? "border-blue-600 bg-blue-200"
              : "border-blue-500 bg-blue-100"
          }`}
          tabIndex={0}
          onDragOver={(e) => {
            e.preventDefault();
            setDragActive(true);
          }}
          onDragLeave={() => setDragActive(false)}
          onDrop={handleDrop}
        >
          {showPreview && fileUrl ? (
            <>
              <img
                src={fileUrl}
                alt="preview"
                className="w-full h-full object-contain rounded"
              />

              <div className="absolute top-2 right-2 flex gap-2">
                <GlobalButton
                  variant="secondary"
                  size="small"
                  onClick={handleEdit}
                >
                  {`Edit`}
                </GlobalButton>

                <GlobalButton
                  variant="warning"
                  size="small"
                  onClick={handleDelete}
                >
                  {`Delete`}
                </GlobalButton>
                <input
                  ref={fileInputRef}
                  hidden
                  type="file"
                  accept={accept}
                  onChange={handleChange}
                />
              </div>
            </>
          ) : (
            <div className="flex flex-col justify-center items-center h-full">
              <img
                src="/assests/uploadFile.webp"
                alt="upload"
                className="object-contain h-10 w-10"
              />

              <span className="mt-2">Drag and drop your file</span>

              <span className="text-gray-600 my-2">or</span>

              <label className="border border-blue-500 py-1 px-3 bg-white rounded-lg text-blue-500 cursor-pointer hover:bg-blue-50">
                {label}

                <input
                  ref={fileInputRef}
                  hidden
                  type="file"
                  accept={accept}
                  onChange={handleChange}
                />
              </label>
              <span className="text-gray-600 my-2">or</span>

              <div className="text-xs text-gray-400 mt-2">
                press{" "}
                <kbd className="px-1 py-0.5 bg-gray-200 rounded border">
                  Ctrl
                </kbd>{" "}
                +{" "}
                <kbd className="px-1 py-0.5 bg-gray-200 rounded border">V</kbd>{" "}
                to paste
              </div>

              {fileUploading && (
                <div className="mt-3">
                  <CircularProgress size={20} />
                </div>
              )}

              {pasteError && (
                <div className="mt-2 text-red-500 text-sm">{pasteError}</div>
              )}
            </div>
          )}
        </div>

        {/* DESCRIPTION */}

        {/* {role === "client" && (
          
          <CustomInput
            name="description"
            placeholder="Enter Description"
            title="Description"
            value={referenceDescription}
            size="small"
            onChange={(e) => {
              setReferenceDescription(e.target.value);

              onChangeDescription?.(e.target.value);
            }}
          />
        )} */}

        {role === "client" && (
          <div className="w-full">
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Description
            </label>

            <textarea
              rows={4}
              placeholder="Enter Description"
              value={referenceDescription}
              onChange={(e) => {
                setReferenceDescription(e.target.value);
                onChangeDescription?.(e.target.value);
              }}
              className="
        w-full
        border
        border-gray-300
        rounded-lg
        p-3
        text-sm
        outline-none
        focus:ring-2
        focus:ring-blue-400
        focus:border-blue-400
        resize-none
      "
            />
          </div>
        )}

        {/* FOOTER BUTTONS */}

        <div className="flex justify-end gap-3 mt-2">
          {fileUploading && (
            <div className="flex items-center justify-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-md">
              <CircularProgress size={18} />

              <span className="text-sm font-medium">
                Uploading image, please wait...
              </span>
            </div>
          )}

          <GlobalButton
            variant="secondary"
            size="small"
            onClick={() => setOpen(false)}
          >
            {`Cancel`}
          </GlobalButton>

          <GlobalButton
            variant="primary"
            size="small"
            disabled={!fileName}
            isLoading={loading}
            onClick={handleSave}
          >
            {`SAVE`}
          </GlobalButton>
        </div>
      </div>
    </div>
  );
};

export default DragDropUpload;
